/**
 * Authentication utilities
 */

import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * Check if current user is in Admin group
 */
export async function isAdminUser(): Promise<boolean> {
  try {
    const session = await fetchAuthSession();
    const groups = session.tokens?.accessToken?.payload?.['cognito:groups'];
    
    if (Array.isArray(groups)) {
      return groups.includes('Admin');
    }
    if (typeof groups === 'string') {
      return groups === 'Admin' || groups.includes('Admin');
    }
    
    return false;
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
}

/**
 * Get user groups from session
 */
export async function getUserGroups(): Promise<string[]> {
  try {
    const session = await fetchAuthSession();
    const groups = session.tokens?.accessToken?.payload?.['cognito:groups'];
    
    if (Array.isArray(groups)) {
      return groups.filter((g): g is string => typeof g === 'string');
    }
    if (typeof groups === 'string') {
      return [groups];
    }
    
    return [];
  } catch (error) {
    console.error('Error getting user groups:', error);
    return [];
  }
}


